import React from 'react';

import { connect } from 'react-redux';
import {
  Button,
} from 'antd';
import {
  Box, Flex,
} from '../../shared/components';
import PELFiltro from '../containers/PELFiltro';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import PropTypes from "prop-types";
import {sendCloseMessageGW1} from "../../../helpers/GW1sendMessage.helper";

class PELFiltrarPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mostrarErroresMontura: false };
  }

  onClick() {
    const { pel: { filtrador: { botonBusquedaEnabled, faltanDatosMontura } }, history, onClick } = this.props;
    if (faltanDatosMontura && botonBusquedaEnabled) {
      this.setState({ mostrarErroresMontura: true });
    } else if (history === undefined) {
      onClick();
    } else {
      history.push('/gw1/pel/seleccionar');
    }
  }
  render() {
    const { pel: { filtrador: { botonBusquedaEnabled } }, onClose, permisos } = this.props;
    const { mostrarErroresMontura } = this.state;
    const verDatosMontura = permisos?.configuracion.micatalogo_verdatosmontura === 'T';
    return (
      <Flex p="16" flexDirection="column">
        <Box flex={1}>
          <PELFiltro mostrarErroresMontura={mostrarErroresMontura}  panelesOcultos={verDatosMontura ? [] : ['montura']}  />
        </Box>
        <Box pt="16" flex={1} justifyContent="flex-end">
          <TwoColumnsFlexLayout
            rightContent={(
              <Flex justifyContent="flex-end">
                <Box mr={12}>
                  <Button
                    onClick={() => onClose()}
                  >
                    Cancelar
                  </Button>
                </Box>
                <Box>
                  <Button onClick={() => this.onClick()} disabled={!botonBusquedaEnabled} type="primary">Buscar lentes</Button>
                </Box>
              </Flex>
            )}
            rightColumnStyle={{ textAlign: 'right' }}
          />

        </Box>
      </Flex>
    );
  }
}

const mapStateToProps = ({ pel, sagas, auth }) => ({
  pel,
  permisos: auth.permisos,
  sagas,
});
PELFiltrarPage.propTypes = {
  onClose: PropTypes.func,
};
PELFiltrarPage.defaultProps = {
  onClose: () => sendCloseMessageGW1(),
};
export default connect(
  mapStateToProps,
  null,
)(PELFiltrarPage);
